import { fonts } from './assets/fonts';

export const MAX_WIDTH = 1280;
export const MAX_HEIGHT = 700;

export const MOBILE_CUTOFF = 700;
export const TEXT_MOBILE_BIG_CUTOFF = 70;
export const TEXT_MOBILE_SMALL_CUTOFF = 17;
export const TEXT_MOBILE_BIG_PERCENT = 0.6;
export const TEXT_MOBILE_SMALL_PERCENT = 0.8;

export const DEFAULT_FONT_FAMILY_NAME = 'inter';
export const FONT_FAMILIES_DEFAULT: Record<string, string> = {
  ...fonts,
  [DEFAULT_FONT_FAMILY_NAME]: fonts.inter,
};

export const LIGHT_THEME = 'light';
export const DARK_THEME = 'dark';

export const NAVIGATION_CONTAINER_IDENTIFIER = 'navigation-menu';

// https://tailwindcss.com/docs/box-shadow
export const BOX_SHADOW_OPTIONS: Record<string, string> = Object.freeze({
  none: '0 0 #0000',
  sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
  md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
  lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
  xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
  '2xl': '0 25px 50px -12px rgb(0 0 0 / 0.25)',
});

export const BOX_SHADOW_VISIBILITY_MARGIN: Record<string, number> = Object.freeze({
  '0 0 #0000': 0,
  '0 1px 2px 0 rgb(0 0 0 / 0.05)': 3,
  '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)': 10,
  '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)': 20,
  '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)': 40,
  '0 25px 50px -12px rgb(0 0 0 / 0.25)': 60,
});

export const RENDERABLE_NODE_KEYS_IN_PAGE_DATA: string[] = [
  'emailCapturePopup',
  'contentGatePopup',
  'postActions',
  'progressIndicator',
];

export const DREAM_COMPONENTS_Z_INDEX_VALUES = {
  dialogOverlay: 50,
  dialogContent: 150,
  stickyNavbar: 48, // should be less than dialogOverlay
  stickyNavbarIslandWrapper: 49, // should be less than dialogOverlay
};
